/* eslint-disable */
import withRender from './country_select.vue.html';

import escapeRegExp from 'lodash/escapeRegExp';

const KEY_CODES = {
    UP: 38
};

export default withRender({
    name: 'country-select',

    props: {
        value: Object,
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        noResultsMessage: {
            type: String,
            default: ''
        },
        withFlags: {
            type: Boolean,
            default: true
        },
        qaDataAttributes: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            filter: '',

            selectedOption: {},

            userHighlightedOptionIndex: 0,
            userHighlightedOptionIndexChanged: false,

            opened: false,
            focused: false,
            showAllOptions: true,
            openOnFilterChange: true
        };
    },

    computed: {
        containerClasses() {
            return {
                'country-selector__open': this.opened,
                'country-selector__focus': this.focused
            };
        },
        filteredOptions() {
            if (!this.filter || this.showAllOptions) {
                return this.options;
            }

            const filterRegExp = new RegExp(escapeRegExp(this.filter), 'i');
            const filteredOptions = this.options.filter(option => filterRegExp.test(option.text));

            return filteredOptions;
        },
        inputFlagIcon() {
            const { selectedOption } = this;

            let flag = 'all';

            if (selectedOption) {
                const optionRegExp = new RegExp(escapeRegExp(selectedOption.text), 'i');

                flag = optionRegExp.test(this.filter) ? selectedOption.value.toLowerCase() : flag;
            }

            return `country-flag__${flag}`;
        },
        highlightedOptionIndex() {
            let index = 0;

            if (this.userHighlightedOptionIndexChanged) {
                index = this.userHighlightedOptionIndex;
            } else if (this.selectedOption && this.filter.length) {
                const optionIndex = this.filteredOptions.findIndex(
                    option => option.value === this.selectedOption.value
                );

                index = optionIndex >= 0 ? optionIndex : 0;
            }

            return index;
        }
    },

    methods: {
        open() {
            this.opened = true;
        },
        close() {
            this.opened = false;
        },
        toggleState() {
            if (this.opened) {
                this.close();
            } else {
                this.open();
                this.focusAndSelect();
                this.showAllOptions = true;

                this.scrollToHighlightedOption();
            }
        },
        focusAndSelect() {
            this.$refs.countrySelectInput.select();
        },
        blur() {
            this.$refs.countrySelectInput.blur();
            this.focused = false;

            if (
                (this.filter && this.filteredOptions.length > 0) ||
                this.userHighlightedOptionIndexChanged ||
                this.selectedOption
            ) {
                if (!this.selectedOption) {
                    this.selectedOption = this.filteredOptions[this.highlightedOptionIndex];
                    this.$emit('input', this.selectedOption);
                }

                this.filter = this.selectedOption.text;
                this.openOnFilterChange = false;
                this.userHighlightedOptionIndexChanged = false;
                this.userHighlightedOptionIndex = 0;
            }

            if (this.opened) {
                this.$nextTick(() => {
                    this.close();
                });
            }
        },
        onEsc() {
            if (this.opened) {
                this.close();
            } else {
                this.blur();
            }
        },
        onFocus() {
            this.focused = true;

            if (!this.selectedOption) {
                this.open();
            }
        },
        onKeyDown(e) {
            if (this.opened) {
                let nextHighlightedOptionIndex =
                    this.userHighlightedOptionIndex === this.highlightedOptionIndex
                        ? this.userHighlightedOptionIndex
                        : this.highlightedOptionIndex;

                nextHighlightedOptionIndex += e.keyCode === KEY_CODES.UP ? -1 : 1;

                const optionsQuantity = this.filteredOptions.length;

                if (nextHighlightedOptionIndex < 0) {
                    nextHighlightedOptionIndex = optionsQuantity - 1;
                } else if (nextHighlightedOptionIndex >= optionsQuantity) {
                    nextHighlightedOptionIndex = 0;
                }

                this.userHighlightedOptionIndex = nextHighlightedOptionIndex;
                this.userHighlightedOptionIndexChanged = true;
            } else {
                this.opened = true;
            }

            this.scrollToHighlightedOption();
        },
        select(option) {
            if (!this.filteredOptions[this.highlightedOptionIndex]) {
                this.blur();
                return;
            }

            this.selectedOption = option || this.filteredOptions[this.highlightedOptionIndex];
            this.$emit('input', this.selectedOption);
            this.blur();
        },
        onSelectChange(e) {
            const newSelectedValue = e.target.selectedOptions[0].value;
            const newSelectedOption = this.options.find(
                option => option.value === newSelectedValue
            );

            this.select(newSelectedOption);
        },
        scrollToHighlightedOption() {
            this.$nextTick(() => {
                const { countrySelectDropdown } = this.$refs;
                const highlightedOption = countrySelectDropdown.querySelector(
                    'li.dropdown-menu_item__active'
                );

                if (countrySelectDropdown.scrollTop > highlightedOption.offsetTop) {
                    countrySelectDropdown.scrollTop = highlightedOption.offsetTop;
                } else if (
                    countrySelectDropdown.scrollTop + countrySelectDropdown.offsetHeight <
                    highlightedOption.offsetTop + highlightedOption.offsetHeight
                ) {
                    countrySelectDropdown.scrollTop =
                        highlightedOption.offsetTop +
                        highlightedOption.offsetHeight -
                        countrySelectDropdown.offsetHeight +
                        2;
                }
            });
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                let newSelectedValue = null;

                if (newValue instanceof Object) {
                    const selectedOptionFromOptionsList = this.options.find(
                        option => option.value === newValue.value
                    );

                    if (selectedOptionFromOptionsList) {
                        newSelectedValue = selectedOptionFromOptionsList;
                        this.openOnFilterChange = false;
                        this.filter = selectedOptionFromOptionsList.text;
                    }
                }

                this.selectedOption = newSelectedValue;
            }
        },
        filter(newFilter) {
            this.showAllOptions = false;

            if (newFilter.length === 0) {
                this.userHighlightedOptionIndex = 0;
            }

            if (this.openOnFilterChange) {
                this.opened = true;
            } else {
                this.openOnFilterChange = true;
            }
        }
    },

    mounted() {
        document.addEventListener('click', this.blur);

        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('click', this.blur);
        });
    }
});
